import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Text } from "@jobber/components/Text";
import AuthFlowFrame from "components/AuthFlowFrame";
import ProXtraPromotionalPanel from "components/ProXtraPromotionalPanel";
import ProXtraSignUpFooter from "components/ProXtraSignUpFooter";
import { useProXtraFlow } from "context";
import { formatPhoneForDisplay } from "helpers";
import StatusTitle from "./Step3-StatusTitle";

// TODO: Confirm the correct Jobber URL for the "Go Back to Jobber" button.
// Per Figma annotation, this should go to the Home Depot integration app
// listing page in the Jobber marketplace.
const JOBBER_HD_MARKETPLACE_URL = "https://secure.getjobber.com/marketplace";

function Step3InUse() {
    const navigate = useNavigate();
    const { phoneNumber } = useProXtraFlow();
    const formattedPhone = formatPhoneForDisplay(phoneNumber);

    const description: ReactNode = (
        <>
            The Pro Xtra account associated with{" "}
            <strong>{formattedPhone}</strong> is connected to another Jobber
            account.
        </>
    );

    return (
        <AuthFlowFrame
            pretitle="Connect your Pro Xtra account"
            title={
                <StatusTitle
                    text="Pro Xtra account in use"
                    iconName="alert"
                    variant="critical"
                />
            }
            description={description}
            sidePanel={<ProXtraPromotionalPanel />}
            secondaryButton={{
                text: "Go Back to Jobber",
                url: JOBBER_HD_MARKETPLACE_URL,
            }}
            primaryButton={{
                text: "Connect a Different Pro Xtra Account",
                onClick: () => navigate("/jobber-homedepot-step1"),
            }}
            footer={<ProXtraSignUpFooter />}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--space-smaller)",
                }}
            >
                <Text>You can either:</Text>
                <ul
                    style={{
                        margin: 0,
                        paddingLeft: "var(--space-large)",
                    }}
                >
                    <li>
                        <Text>
                            Connect a different Pro Xtra account using another
                            phone number
                        </Text>
                    </li>
                    <li>
                        <Text>
                            Disconnect Pro Xtra from the other Jobber account
                            then connect it here
                        </Text>
                    </li>
                </ul>
            </div>
        </AuthFlowFrame>
    );
}

export default Step3InUse;
